/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TOGGLE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    switch: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        padding: pxToEm(4),
        borderRadius: pxToEm(100),
        cursor: 'pointer',
        width: pxToEm(78),
        height: pxToEm(42),
        transition: 'all .05s ease-in-out .05s',
        '& .ball':{
            height: pxToEm(34),
            width: pxToEm(34),
            borderRadius: 50,
            background: theme.color.light.light.swatch,
            position: 'absolute',
            left: pxToEm(4),
            transition: 'all .05s ease-in-out .05s'
        },
        '&.active-true':{
            '& .ball':{
                left:'50%'
            },
            '&.variant-primary':{
                background: theme.color.primary.medium.swatch
            },
            '&.variant-secondary':{
                background: theme.color.secondary.medium.swatch
            },
        },
        '&.active-false':{
            '&.variant-primary':{
                background: theme.color.neutral.light.swatch
            },
            '&.variant-secondary':{
                background: theme.color.attention.medium.swatch
            }
        }
    }
});
